var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.constraints),function(constraint,index){return _c('FieldConstraintItem',{key:index,attrs:{"constraint":constraint,"index":index,"field":_vm.field,"disabled":_vm.disabled,"error":_vm.error,"allowed-constraint-types":_vm.getAvailableConstraintTypes(index)},on:{"update":_vm.updateConstraint,"remove":_vm.removeConstraint}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }